import { useContext } from "react";
import { CrossRed } from "src/assets";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import officina from "src/fonts/officina.woff2";
import { SITE_AUTHENTICATION_ROUTES } from "src/consts/routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";
import { MicroFrontendDetails, SESSION_KEYS } from "src/consts/session";

const Failed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const msgId = searchParams.get("msgId") || "";
  const themeName = useContext(ThemeContext);

  const [getMicroFrontendDetails] = useSessionStorage<MicroFrontendDetails>(
    SESSION_KEYS.MICRO_FRONTEND_DETAILS,
  );

  const showIncompatibleMsg =
    msgId === "hardwareIncompatible" || msgId === "serialMismatch";

  const [getTransferId] = useSessionStorage<string>(SESSION_KEYS.TRANSFER_ID);

  const handleTryAgain = () => {
    const transferId = getTransferId();

    navigate(
      `${SITE_AUTHENTICATION_ROUTES.START}?theme=${themeName}&tid=${transferId}`,
    );
  };

  const handleContact = () => {
    window.location.href = "https://www.lichtblick.de/kontakt/";
  };

  return (
    <Stack gap={5}>
      <Stack alignItems={"start"}>
        <CrossRed />
      </Stack>

      <Text
        text={t("page.siteAuthenticationError.pageTitle")}
        sx={(theme) => ({
          fontSize: "32px",
          fontWeight: "500",
          lineHeight: "40px",
          color: "#A1241B",
          fontFamily: "officina",
          "@font-face": {
            fontFamily: "officina",
            src: `url(${officina}) format("woff2")`,
          },
        })}
      />

      {showIncompatibleMsg && (
        <Stack gap={1}>
          <Text
            text={t("page.siteAuthenticationError.pageSubTitle2")}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "700",
              lineHeight: "20px",
              fontFamily: "Inter",
            })}
          />
          <Text
            text={t("page.siteAuthenticationError.pageSubTitle3")}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
            })}
          />

          <Stack>
            <li
              style={{
                color: "black",
                marginLeft: "40px",
              }}
            >
              <Text
                text={t("page.siteAuthenticationError.listItem1")}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                })}
              />
            </li>

            <li
              style={{
                color: "black",
                marginLeft: "40px",
              }}
            >
              <Text
                text={t("page.siteAuthenticationError.listItem2")}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                })}
              />
            </li>

            <li
              style={{
                color: "black",
                marginLeft: "40px",
              }}
            >
              <Text
                text={t("page.siteAuthenticationError.listItem3")}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                })}
              />
            </li>
            <li
              style={{
                color: "black",
                marginLeft: "40px",
              }}
            >
              <Text
                text={t("page.siteAuthenticationError.listItem4")}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                })}
              />
            </li>
          </Stack>
        </Stack>
      )}

      <Text
        text={t("page.siteAuthenticationError.pageSubTitle1", {
          hemProvider: getMicroFrontendDetails()?.hemProvider,
        })}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
        })}
      />

      <Stack gap={2}>
        <Box>
          <PrimaryButton
            onClick={handleTryAgain}
            text={t("page.siteAuthenticationError.button3")}
            sx={(theme) => ({
              width: "100%",
              fontSize: "14px",
              lineHeight: "20px",
              maxWidth: { sm: "320px" },
              color: theme.palette.mainFont.primary,
            })}
          />
        </Box>

        <Box>
          <PrimaryButton
            sx={(theme) => ({
              fontSize: "14px",
              lineHeight: "20px",
              color: theme.palette.secondaryButton.text,
              bgcolor: "#3B3B3B",
              "&:hover": {
                backgroundColor: "#3B3B3B",
              },
              textTransform: "none",
              border: "0.829px solid #2E2E2E",
              width: "100%",
              maxWidth: { sm: "320px" },
            })}
            onClick={handleContact}
            text={t("page.siteAuthenticationError.button4")}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default Failed;
